import MyCreditLife from './MyCreditLife'

export default MyCreditLife
